import { branding as fetchBranding } from '@/api/settings';
import { useSettingsStore } from '@/stores';

/**
 * Apply branding to the document (tab title + favicon).
 */
export function applyDocumentBranding(b) {
    if (!b) return;

    document.title = b.business_name || 'HTV Shop';

    const iconUrl = b.logo_url || b.portal_logo_url;
    if (iconUrl) {
        let link = document.querySelector("link[rel~='icon']");
        if (!link) {
            link = document.createElement('link');
            link.rel = 'icon';
            document.head.appendChild(link);
        }
        link.href = iconUrl;
    }
}

/**
 * Fetch branding (public endpoint), store it, and apply it to the document.
 * Safe to call on app bootstrap; failures are ignored.
 */
export async function loadBranding() {
    const store = useSettingsStore();
    try {
        const { data } = await fetchBranding();
        if (data?.branding) {
            store.setBranding(data.branding);
            applyDocumentBranding(data.branding);
        }
        return data?.branding;
    } catch (e) {
        // Non-fatal: keep whatever branding is already cached.
        return null;
    }
}

export default { loadBranding, applyDocumentBranding };
